var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", "pa-3": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "secondary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v("\n          Unit In Media Type\n        "),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Search Media Type:",
                      autofocus: "",
                      clearable: "",
                      color: "white",
                      box: "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { float: "right" },
                      attrs: { color: "success", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addAlia()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Add_a_new_Media_Type")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.UnitInMediaType,
                      pagination: _vm.pagination,
                      search: _vm.search,
                    },
                    on: {
                      "update:pagination": function ($event) {
                        _vm.pagination = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.MediaType)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticStyle: { width: "50%" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    items: ["Concentration", "Volume"],
                                    "single-line": "",
                                  },
                                  model: {
                                    value: props.item.UnitGroup,
                                    callback: function ($$v) {
                                      _vm.$set(props.item, "UnitGroup", $$v)
                                    },
                                    expression: "props.item.UnitGroup",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticStyle: { float: "left", bottom: "45px" },
                      attrs: { color: "success", dark: "" },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Save")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.addDialog,
            callback: function ($$v) {
              _vm.addDialog = $$v
            },
            expression: "addDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Add Media Type")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.addDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                        [
                          _c("v-select", {
                            attrs: { items: ["123"], label: "Tenant" },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: ["Concentration", "Volume"],
                              label: "Unit Group",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-btn", { attrs: { color: "add", dark: "" } }, [
                    _vm._v(_vm._s(_vm.$t("Button.Save"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }